module.exports = __webpack_public_path__ + "static/media/mb-usb.601f110c.jpg";